import * as types from './mutation-types'

export const loadCheckoutStatus = ({commit, dispatch, state}, data) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/orders/status').then((response) => {
      commit(types.LOAD_CHECKOUT_STATUS, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getSocietyInfo = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/society/information', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const updateSocietyInfo = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('store/society/information', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateAuthConfig = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('store/society/auth-config', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}